export default class AnnotationService {
    constructor() {}

    populateMentionnedStaffsIds(description) {
        let regex = /(?:data-id=")+(\d+)/gm;
        let dataMentionFound;
        let staffsMentioned = [];
        while ((dataMentionFound = regex.exec(description)) !== null) {
            staffsMentioned.push(parseInt(dataMentionFound[1]));
        }
        staffsMentioned = _.uniq(staffsMentioned);
        return staffsMentioned;
    }

    populateLinkedType(linkedType) {
        const linkedTypeMap = {
            third: () =>
                window.sellsyapp.$store.getters.identity.isCorporation ? 'company' : 'individual',
            people: () => 'contact',
            purOrder: () => 'purchase-order',
            purDelivery: () => 'purchase-delivery',
            purInvoice: () => 'purchase-invoice',
            purCreditNote: () => 'purchase-creditnote',
            proptemplate: () => 'redactor-template',
            propdocument: () => 'redactor-document',
            corporation: () => 'company',
            person: () => 'individual',
        };
        return linkedTypeMap[linkedType] !== undefined ? linkedTypeMap[linkedType]() : linkedType;
    }

    createAnnotation(description, linkedId, linkedType, parentId, timetracking) {
        let annotation = {
            description: description,
            parent_id: parentId,
            mentioned_staff_ids: this.populateMentionnedStaffsIds(description),
            timetracking: timetracking,
        };

        if (parentId === 0 && (linkedId || linkedType)) {
            annotation = {
                ...annotation,
                related: [
                    {
                        id: linkedId,
                        type: this.populateLinkedType(linkedType),
                    },
                ],
            };
        }

        return new Promise((resolve, reject) => {
            ApiClient.post('/comments', { embed: ['owner'] }, annotation)
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    updateAnnotation(id, description, timetracking) {
        return new Promise((resolve, reject) => {
            ApiClient.put(
                '/comments/' + id,
                {},
                {
                    description: description,
                    timetracking: timetracking,
                },
            )
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    deleteAnnotation(id) {
        return ApiClient.del(`/comments/${id}`);
    }
}
